import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { VendorFormWrapperComponent } from '../vendor-form/vendor-form-wrapper.component';

@Component({
  selector: 'app-vendor-view',
  standalone: true,
  imports: [CommonModule, VendorFormWrapperComponent],
  templateUrl: './vendor-view.component.html',
  styleUrl: './vendor-view.component.css',
})
export class VendorViewComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private destroy$ = new Subject<void>();
  vendorId = signal<string | null>(null);

  ngOnInit(): void {
    // Subscribe to route parameter changes to handle navigation
    // between different vendor view pages
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const id = params.get('id');
      this.vendorId.set(id);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

